import practicalClassLayout from "@/views/practicalClass/index.vue";

export const practicalClassRouter = [
  {
    path: "/practicalClass",
    name: "PracticalClass",
    component: practicalClassLayout,
    hidden: true,
    redirect: "/practicalClass/real-needs",
    children: [
      {
        path: "real-needs",
        name: "RealNeeds",
        component: () => import("@/views/practicalClass/realNeeds/index.vue"),
        meta: {
          title: "真实需求",
        },
      },
      {
        path: "need-manage",
        name: "NeedManage",
        component: () => import("@/views/practicalClass/needManage/index.vue"),
        meta: {
          title: "需求管理",
        },
      },
      {
        path: "question-publish",
        name: "QuestionPublish",
        component: () =>
          import("@/views/practicalClass/questionPublish/index.vue"),
        meta: {
          title: "出题与发布",
        },
      },
      {
        path: "homework-review",
        name: "HomeworkReview",
        component: () =>
          import("@/views/practicalClass/homeworkReview/index.vue"),
        meta: {
          title: "作业批阅",
        },
      },
      {
        path: "course-materials",
        name: "CourseMaterials",
        component: () =>
          import("@/views/practicalClass/courseMaterials/index.vue"),
        meta: {
          title: "课程资料",
        },
      },
      {
        path: "crm-sync",
        name: "CrmSync",
        component: () => import("@/views/practicalClass/crmSync/index.vue"),
        meta: {
          title: "学员成绩",
        },
      },
      {
        path: "question-wall",
        name: "QuestionWall",
        component: () =>
          import("@/views/practicalClass/questionWall/index.vue"),
        meta: {
          title: "问题与投票",
        },
      },
      {
        path: "question-detail",
        name: "QuestionDetail",
        component: () =>
          import("@/views/practicalClass/questionDetail/index.vue"),
        meta: {
          title: "问题放大与回复",
        },
      },
    ],
  },
];
